import axios from 'axios'

export const jobsModule = {
  state: {
    jobs: []
  },
  mutations: {
    storeJobs: (state, jobs) => {
      state.jobs = jobs
    }
  },
  actions: {
    getJobs: (context) => {
      return axios
        .get('https://apply.workable.com/api/v1/widget/accounts/40415/?details=true&origin=embed')
        .then((response) => {
          context.commit('storeJobs', response.data.jobs)
        })
        .catch(error => console.error(error))
    }
  },
  getters: {
    getJob: (state) => (jobKey) => {
      return state.jobs[jobKey]
    }
  }
}

export default jobsModule
